<template>
  <label class="d-flex ms-auto mb-3">
    <span class="align-content-center me-3">
      {{ $t("Show") }}: 
    </span>
    <select2 
      style="width: 70px;"
      v-model="perPage"
      :options="perPageOptions"
      :settings="perPageSettings"
      @select="SelectEvent" 
    />
  </label>
</template>

<script lang="js">
import Select2 from 'vue3-select2-component';
import { PerPage } from "@/configure/index";

export default {
  data() {
    return {
      perPageOptions: PerPage(),
      perPageSettings: {
        minimumResultsForSearch: Infinity,
      },
      perPage: '10',
    }
  },
  components: {
    Select2
  },
  methods: {
    SelectEvent({id, text}){
      this.$emit('per-page', text);
    },
  }
}
</script>